import { useMemo, useRef } from 'react';
import { createAnimatePlugin, type AnimateOptions } from 'streamdown';

// TODO(askpage-streaming): Streaming fade-in animation is not working in the UI yet. The Streamdown
// animate plugin and CSS are wired up, but new words still appear abruptly — revisit and fix later.
const DEFAULT_STREAM_ANIMATION: AnimateOptions = {
  animation: 'fadeIn',
  duration: 360,
  easing: 'ease-out',
  stagger: 16,
};

export const useMarkdownStreamAnimation = (isStreaming: boolean) => {
  const animatePlugin = useMemo(() => createAnimatePlugin(DEFAULT_STREAM_ANIMATION), []);
  const wasStreamingRef = useRef(false);
  const hasStreamedRef = useRef(false);

  if (isStreaming && !wasStreamingRef.current) {
    animatePlugin.setPrevContentLength(0);
    animatePlugin.getLastRenderCharCount();
  } else {
    animatePlugin.setPrevContentLength(animatePlugin.getLastRenderCharCount());
  }

  if (isStreaming) hasStreamedRef.current = true;
  wasStreamingRef.current = isStreaming;

  if (!isStreaming && !hasStreamedRef.current) return null;

  return animatePlugin.rehypePlugin;
};
